import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingCart: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 10.67H32v4.57h-1.53Zm-1.52 4.57h1.52v4.57h-1.52Zm-1.52 4.57h1.52v3.05h-1.52Zm-1.53-6.09h1.53v4.57H25.9Zm-13.71 9.14h15.24v1.52H12.19Zm12.19-4.57h1.52v3.04h-1.52Zm-4.57-4.57h1.52v7.61h-1.52Zm-4.58 4.57h1.53v3.04h-1.53Zm-1.52-4.57h1.52v4.57h-1.52Zm-1.52 15.23v1.53h1.52V32h3.05v-1.52h1.52v-1.53h3.05v1.53h1.52V32h3.05v-1.52h1.53v-1.53h3.04v-1.52H25.9v-1.52h-3.05v1.52h-6.09v-1.52h-3.05v1.52h-3.05v1.52zm-1.53-4.57h1.53v1.53h-1.53Zm0-6.09h1.53v4.57h-1.53Z\"/><path fill=\"currentColor\" d=\"M9.14 25.91h1.52v1.52H9.14Zm0-12.19h1.52v4.57H9.14Zm0 0v-3.05h21.33V9.14H7.62v4.58zM6.09 6.1h1.53v3.04H6.09ZM4.57 3.05h1.52V6.1H4.57ZM3.04 1.52h1.53v1.53H3.04ZM0 0h3.04v1.52H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingCart
